<template>
    <div v-if="isShow" class="bread" :data="data">
        <el-breadcrumb separator="/" open >
            <el-breadcrumb-item
            v-for="(item,index) in data" 
            :key="index" 
            :to="item.path" 
            >{{item.title}}</el-breadcrumb-item>
        </el-breadcrumb>
        <h1>{{data[data.length-1].title}}</h1>
    </div>
</template>
<script>
export default {
    data () {
        return {
            isShow: this.data.length == 0 ? false : true
        }
    },
    props: {
        data: {
            type: Array
        }
    },
    watch:{
        $route(event){
            if(event.meta.record.length == 0){
                this.isShow = false;
            }else{
                this.isShow = true;
                this.data = event.meta.record;
            }
        }
    },
}
</script>
<style>
    .bread{
        display: flex;
        width: 100%;
        box-sizing: border-box;
        flex-flow: column;
        justify-content: space-between;
        padding: 16px 0 0 0;
        box-sizing: border-box;
    }
    .bread .el-breadcrumb{
        display: flex;
        height: 25px;
        line-height: 16px;
        align-items: flex-end;
        box-sizing: border-box;
        padding:  0 0 9px 0;
        font-size:12px;
    }
    .bread h1{
        line-height: 24px;
        font-size: 18px;
        color: #333;
        font-weight: 500;
        padding-bottom: 19px;
    }
    .bread .el-breadcrumb__inner{
        font-size: 12px !important;
        font-family: MicrosoftYaHei;
        color: #AAAAAA !important;
    }   
</style>


// WEBPACK FOOTER //
// src/components/Bread.vue